import React from 'react';
import { TemplateOverview } from '../styles';
import { Carousel, Icon, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { SHORT_MESSAGE_TEMAPLTES_PREVIEW } from './translationValues';
import { IS_WHATSAPP_ENABLED } from '../../../utils/helper';

/* This component contains templates data preview (kind of image preview)
  Child Components: 
    ******
*/
const NAMESPACES = ['SHORT_MESSAGE_TEMAPLTES_PREVIEW'];
const TemplateDataPreview = ({ templateObj, onMenuClick, onPreviewClick, renderDropDown, languageList }) => {
  const truncate = input => (input.length > 50 ? `${input.substring(0, 50)}...` : input);

  const renderMessage = input => {
    let templateContent = '';
    input.map(value => {
      templateContent = templateContent + value.textValue;
    });
    return truncate(templateContent);
  };
  const { t } = useTranslation(NAMESPACES);
  const whatsAppValue = IS_WHATSAPP_ENABLED && templateObj.whatsapp ? renderMessage(templateObj.whatsapp) : null;
  const smsValue = templateObj.sms ? renderMessage(templateObj.sms) : null;
  const callValue = templateObj.call ? renderMessage(templateObj.call) : null;
  return (
    <TemplateOverview key={templateObj.id} onClick={onMenuClick} title={templateObj.name}>
      <div className="template-media">
        <div className="image-wrapper">
          <Carousel autoplay dots={false}>
            {whatsAppValue && whatsAppValue !== '' && (
              <div className="data-carousel">{whatsAppValue}</div>
            )}
            {smsValue && smsValue !== '' && <div className="data-carousel">{smsValue}</div>}
            {callValue && callValue !== '' && <div className="data-carousel">{callValue}</div>}
          </Carousel>
        </div>
        <Tooltip title={t(SHORT_MESSAGE_TEMAPLTES_PREVIEW.PREVIEW_TEMPLATE_TOOLTIP.key, SHORT_MESSAGE_TEMAPLTES_PREVIEW.PREVIEW_TEMPLATE_TOOLTIP.value)} placement={"top"}>
          <div className="preview-button" onClick={onPreviewClick}>
            <Icon type="eye" />
          </div>
        </Tooltip>
        {renderDropDown && renderDropDown()}
      </div>
      <div className="template-name">
        <h2>{templateObj.name}</h2>
        {templateObj?.language && (
          <Tooltip title={languageList?.find(ln => ln.code === templateObj?.language)?.name} trigger="hover">
            <div className={'language-tag'}>{templateObj?.language}</div>
          </Tooltip>
        )}
      </div>
    </TemplateOverview>
  );
};

export default TemplateDataPreview;
